import React, {useState} from 'react';
import {ActivityIndicator, Image, Platform} from 'react-native';
import styled from 'styled-components/native';
import {useTheme} from 'styled-components';
import {ProgressiveImageProps} from '../../interfaces/components/progressiveImage';

// On web, we'll just use the standard Image component
// We use a dynamic import approach that prevents webpack from trying to resolve
// the module at build time
let FastImage = Image;
if (Platform.OS !== 'web') {
  try {
    // Use require in a try/catch to prevent build errors
    const FastImageModule = require('react-native-fast-image');
    FastImage = FastImageModule.default || FastImageModule;
  } catch (e) {
    // Fallback to regular Image if FastImage is not available
  }
}

const Container = styled.View`
  width: 100%;
  height: 100%;
`;
const LoadingContainer = styled.View`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  align-items: center;
  justify-content: center;
`;

const ProgressiveImage = (props: ProgressiveImageProps) => {
  const theme = useTheme();
  const [showDefault, setShowDefault] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState<boolean>(true);

  const defaultImage: any = props?.defaultImage
    ? typeof props.defaultImage === 'string'
      ? {uri: props.defaultImage}
      : props.defaultImage
    : require('../../assets/images/placeholderImage.jpg');

  const imageSource =
    showDefault || !props.source || !(props?.source as any)?.uri || error
      ? defaultImage
      : typeof (props?.source as any)?.uri === 'string'
        ? props.source
        : (props?.source as any)?.uri;

  const handleLoadStart = () => {
    setShowDefault(false);
    setLoading(true);
  };

  const handleLoadEnd = () => {
    setShowDefault(false);
    setLoading(false);
  };

  const handleError = () => {
    setError(true);
    setShowDefault(true);
  };

  return (
    <Container style={props.containerStyle}>
      {loading && !props.hideLoader && (
        <LoadingContainer {...props}>
          <ActivityIndicator size={'small'} color={theme.primary} />
        </LoadingContainer>
      )}

      {Platform.OS === 'web' ? (
        <Image
          style={[
            {width: '100%', height: '100%'},
            // @ts-ignore - Handle different style prop types
            props.style,
          ]}
          source={imageSource}
          resizeMode={props.resizeMode || 'cover'}
          onLoadStart={handleLoadStart}
          onLoad={handleLoadEnd}
          onError={handleError}
        />
      ) : (
        <FastImage
          {...props}
          style={[
            {width: '100%', height: '100%'},
            // @ts-ignore - Handle different style prop types
            props.style,
          ]}
          onLoadStart={handleLoadStart}
          onLoadEnd={handleLoadEnd}
          onError={handleError}
          resizeMode={props.resizeMode || 'cover'}
          source={imageSource}
        />
      )}
    </Container>
  );
};

export default ProgressiveImage;
